"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavButton = void 0;
var _Button = require("../../../elements/button/Button");
var _react = _interopRequireDefault(require("react"));
var _CategoryList = require("../category-list/CategoryList");
var _DropdownIcon = require("../dropdown-icon/DropdownIcon");
var NavButton = function NavButton(_ref) {
  var title = _ref.title,
    visible = _ref.visible,
    items = _ref.items;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.StandardButton, null, title, /*#__PURE__*/_react.default.createElement(_DropdownIcon.DropdownIcon, null)), visible && /*#__PURE__*/_react.default.createElement(_CategoryList.CategoryList, {
    items: items
  }));
};
exports.NavButton = NavButton;